import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextField, Label } from 'src/jbc-front/components/Form';
import { isNumber } from 'src/utils/CustomValidators';

import styles from './EmployeePayForm.scss';

const DiligenceSectionMockup = ({ fields, isViewOnly }) => {
  const { t } = useTranslation();
  return (
    <tbody>
      {fields.length > 0 &&
        fields.map((field, index) => (
          <tr key={`ps.${index + 1}`}>
            <th>{t('features.EmployeePays.components.DiligenceSectionMockup.motivation_name', { name: field.label })}</th>
            <td className={styles.value} style={{ textAlign: 'right' }}>
              {isViewOnly ? (
                <Label text={field.value} />
              ) : (
                <TextField name={`motivationStreaks[${index}].value`} width={100} type="number" validate={isNumber} textAlign="right" />
              )}
            </td>
          </tr>
        ))}
    </tbody>
  );
};

export default DiligenceSectionMockup;
